import { render, staticRenderFns } from "./InvestimentiListTable.vue?vue&type=template&id=323e5088&"
import script from "./InvestimentiListTable.vue?vue&type=script&lang=js&"
export * from "./InvestimentiListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports